export default __webpack_public_path__ + "static/media/alert.34cc8be0.svg";